import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=55afb232&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=55afb232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55afb232",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,PackageCard: require('/usr/src/motec/components/package/Card.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default,Error: require('/usr/src/motec/components/Error.vue').default})
